module.exports = __webpack_public_path__ + "img/audio-description.3ea6cb28.svg";